<div class="header drop-shadow px-2 border-b">
    <div class="flex items-center gap-0 cursor-pointer">
        <!-- Hamburger Menu Icon to Toggle Sidebar -->
        @if(sidebarId) {
        <app-button (clicked)="toggleSidebar()" variant="text"
            [pTooltip]="'Toggle Sidebar (' + sidebarToggleShortcut + ')'" tooltipPosition="bottom"
            [iconSize]="'default'" [icon]="(sidebarVisible$ | async) ? 'panel-right-open' : 'panel-right-close'"
            [iconSource]="'lucide'" />
        }
        <!-- Hide breadcrumb on mobile when on general-agent route -->
        @if(!isMobile() || !isGeneralAgentRoute()) {
        <app-breadcrumb></app-breadcrumb>
        }
    </div>

    <div class="flex items-center gap-2">

        <app-credits-overview variant="chip"></app-credits-overview>

        <!-- Subscription badge: desktop only (mobile lives inside Quick Actions dialog) -->
        @if(!isMobile() && subscriptionState.subscriptionDetails() && subscriptionState.subscriptionDetails()?.plan &&
        ENV.enableSubscription){
        @if(subscriptionState.isTrial()) {
        <app-button variant="outlined" [severity]="subscriptionPhaseLabel.severity"
            [label]="subscriptionPhaseLabel.label" [class]="subscriptionPhaseLabel.styleClass"
            (clicked)="canAccessPricing() ? navigateToPricing() : null" />
        }
        @else {
        @if(subscriptionState.plan()?.name){
        <app-button variant="outlined" [severity]="subscriptionPaymentStatusLabel.severity"
            [class]="subscriptionPaymentStatusLabel.styleClass" [label]="subscriptionPaymentStatusLabel.label"
            (clicked)="canAccessPricing() ? navigateToPricing() : null" [icon]="'chevron-right'" [iconSource]="'lucide'"
            [iconPosition]="'right'" />
        }
        }
        }

        <div class="flex items-center justify-center w-9 h-9 bg-white border border-gray-200 rounded-lg">
            <app-notifications class="cursor-pointer"></app-notifications>
        </div>

        <app-menu #support [items]="supportMenuItems" [attr.step-id]="'support-menu'">
            <div class="flex items-center gap-1 p-[9px] border border-gray-200 rounded-lg"
                [ngClass]="{'cursor-not-allowed opacity-50': isRecording, 'cursor-pointer': !isRecording, 'bg-primary': support.isVisible}"
                (click)="support.toggle($event)" [pTooltip]="'Support'" tooltipPosition="left">
                <app-icon [type]="TOP_BAR_SVG.SUPPORT" [source]="'svg'" [size]="'sm'" />
                <app-icon [type]="support.isVisible ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
                    [source]="'primeng'" [size]="'sm'" />
            </div>
        </app-menu>
        <app-menu #info [items]="infoMenuItems">
            <div class="flex items-center gap-1 cursor-pointer p-[9px] border border-gray-200 rounded-lg"
                [ngClass]="{'bg-primary': info.isVisible}" (click)="info.toggle($event)" [pTooltip]="'Assistance'"
                tooltipPosition="left">
                <app-icon [type]="TOP_BAR_SVG.ASSISTANCE" [source]="'svg'" [size]="'sm'" />
                <app-icon [type]="info.isVisible ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" [source]="'primeng'"
                    [size]="'sm'" />
            </div>
        </app-menu>
    </div>

</div>


<app-dialog [visible]="supportTicketDialogVisible" [title]="'Raise a Support Ticket' | textCase"
    [fullscreenOnMobile]="true" class="max-w-[40rem] h-[41rem]" (closed)="onSupportTicketDialogHide()">
    <ng-template #bodyTemplate>
        <div class="px-6 py-4 h-full overflow-y-auto">
            <app-support-ticket-form #supportTicketForm [isDialog]="true"
                (ticketSubmitted)="onSupportTicketSubmitted()">
            </app-support-ticket-form>
        </div>
    </ng-template>
</app-dialog>

<app-capture-issue #captureIssue (captureCompleted)="onCaptureCompleted($event)"></app-capture-issue>